import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BarLoader from "react-spinners/BarLoader";
import "./refreshpage.css";

const RefreshUpdate =()=>
{
    const navigate = useNavigate();

    const  [loading,setLoading] = useState(false);
    useEffect(
        ()=>{
            setLoading(true)
           
            setTimeout(()=>{
                setLoading(false)
                navigate('/abc/');

            },5000)
        },[]
    )
    return(
        loading ?
        <div>
            <center className="stylingtologo">
            
             
             <BarLoader

                    color={"#0E5C95"}
                      loading={loading}
                     size={150}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                    
                    
             />
             <h1>Updating Query!</h1>
            </center>
            
                 
        </div>
       
       
        :

        <div>
               useEffect();
        </div>
    )
}
export default RefreshUpdate;